import ServiceTextBoxContainer from './ServiceTextBoxContainer';

export default ServiceTextBoxContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/ServiceTextBox/index.js